/**
 * Category-specific ad form fields for ClubLoop.
 * Aggregates all golf-specific field definitions from generalFields.
 */
import { generalFields } from './generalFields';

export const CATEGORY_FIELDS = {
  // Mapping the keys exactly as they appear in your mainCategories/legacyCategories IDs
  'drivers': generalFields['Drivers'],
  'iron-sets': generalFields['Iron Sets'],
  'putters': generalFields['Putters'],
  'fairway-woods-hybrids': generalFields['Drivers'], // Reusing Driver logic for Woods
  'wedges': generalFields['Iron Sets'],              // Reusing Iron logic for Wedges
  'full-sets': generalFields['Iron Sets'],           // Reusing Iron logic for Sets
  'golf-bags': generalFields['Golf Bags'],
  'tech-rangefinders': generalFields['Tech & Rangefinders'],
  'apparel-men': generalFields['Apparel'],
  'apparel-women': generalFields['Apparel'],
  'golf-shoes': generalFields['Golf Shoes'],

  // Legacy mapping for backward compatibility
  'men-golf': generalFields['Iron Sets'],
  'women-golf': generalFields['Iron Sets'],
  'junior-golf': generalFields['Iron Sets'],
  'tech-accessories': generalFields['Tech & Rangefinders'],
};

/**
 * Get extra form fields for a category (by ID/Name).
 */
export function getCategoryFields(categoryName) {
  if (!categoryName) return [];
  // Using the ID (e.g., 'iron-sets') is safer than the display name
  return CATEGORY_FIELDS[categoryName] || [];
}

/**
 * Default values for category-specific fields.
 * Ensures form state is initialized correctly for the Grade System and Technical Specs.
 */
export function getDefaultCategoryFields(categoryName) {
  const fields = getCategoryFields(categoryName);
  const defaults = {};

  fields.forEach((f) => {
    if (f.type === 'checkbox') {
      defaults[f.key] = false;
    } else if (f.type === 'number') {
      defaults[f.key] = f.min || 0;
    } else {
      defaults[f.key] = '';
    }
  });

  return defaults;
}
